/* Local url's */
export const HOME = "/";
export const TOPICS = "/topics";
export const CERTAIN_TOPIC = TOPICS + "/id=:id";
export const CERTAIN_TOPIC_AWAITING_ID = TOPICS + "/id=";
export const NO_MATCH_404_PAGE = "*";
export const REGISTER = "/register";
export const LOG_IN = "/logIn";
export const LINKED_IN = "/linkedin";
export const SEARCH = "/search";
export const SEARCH_BY_TEXT = SEARCH + "/free_text=:free_text";
export const SEARCH_BY_TEXT_AWAITING_TEXT = SEARCH + "/free_text=";
export const DOCUMENT = "/document";
export const GET_DOCUMENT_BY_ID = DOCUMENT + "/id=:id";
export const GET_DOCUMENT_BY_ID_AWAITING_ID = DOCUMENT + "/id=";
export const GROUP_OF_TILES = "/groupOfTiles";
export const GROUP_OF_TILES_BY_ID = GROUP_OF_TILES + "/id=:id";
export const GROUP_OF_TILES_BY_AWAITING_ID = GROUP_OF_TILES + "/id=";

export const EARTH_ICON =
  "https://mcusercontent.com/105f374ebef5668c57129751a/images/a2424e70-cf84-49e8-713b-31b93d0e39a0.png";

/* String constants used as labels througout the app */
export const TITLE_BESIDE_LOGO = "The Recap";

/* LinkedIn necessary data for access */
export const CLIENT_ID_LINKEDIN_API = "78fp5dt8ooaz19";
export const CLIENT_SECRET = "6A2WrN1DWOGVFKmC";
export const RESPONSE_TYPE = "code";
export const REDIRECT_URI =
  !process.env.NODE_ENV || process.env.NODE_ENV === "development"
    ? "http://localhost:3000/linkedin"
    : window.location.origin + "/linkedin";
export const SCOPE = "r_liteprofile+r_emailaddress";
export const GRANT_TYPE = "authorization_code";

/* Field properties */
export const FIRST_NAME = "FIRST_NAME";
export const LAST_NAME = "LAST_NAME";
export const USER_EMAIL = "USER_EMAIL";
export const PASSWORD = "PASSWORD";
export const CHECK_BOX = "CHECK_BOX";
export const NEW_PASSWORD = "NEW_PASSWORD";
export const REPEATED_NEW_PASSWORD = "REPEATED_NEW_PASSWORD";
export const TOPIC_NAME = "TOPIC_NAME";
export const TOPIC_MULTI_CHECKBOX = "TOPIC_MULTI_CHECKBOX";
export const TOPIC_AUDIENCE = "TOPIC_AUDIENCE";
export const TOPIC_ICON_PATH = "TOPIC_ICON_PATH";
export const TOPIC_SEARCHTAGS = "TOPIC_SEARCHTAGS";

/* Placeholders */
export const WORKSPACE_TYPE_PRIVATE = "private";
export const WORKSPACE_TYPE_PUBLIC = "public";
// export const IMAGE_BASE = "https://www.reghub.io/img/";
export const IMAGE_BASE = "https://app.reghub.io/im-suite/static/img/";
export const WORKSPACE_IMAGE_PATH_ON_ERROR = IMAGE_BASE + "/RegHub-Lite.jpg";
export const TOPIC_IMAGE_PATH_ON_ERROR = IMAGE_BASE + "/topic.jpg";
export const PUBLIC_USER = "public_user";
export const TRUE = "TRUE";
export const FALSE = "FALSE";
export const PREVIEW = "preview";
export const TILE_TYPE_TEXT = "text";
export const TILE_TYPE_LINKS = "links";
export const TILE_TYPE_IMPACT = "impact";
export const TILE_TYPE_DECISION = "yes/no";
export const TILE_TYPE_DATE = "date";
export const TILE_TYPE_RISKS = "risks";
export const TILE_TYPE_SOURCE = "source";
export const TILE_TYPE_GROUP_OF_TILES = "Group of tiles";
export const PARTNER = "partner";
export const TILE_TYPE_AI_ANALYSIS = "Ai Analysis";
